import React, { Component, PropTypes } from 'react';
import idx from 'idx';
import Money from 'common/components/money';
import { reduxForm, Field, SubmissionError } from 'redux-form';
import ModalDialog from 'common/components/modal/modal_dialog';
import AnimatedButton from 'common/components/animated_button';
import { PackageOptions } from 'pap/components/common/input_fields/package_options';
import PaymentMethod from 'common/containers/payment_method';
import { preventDefault } from 'common/utils';

/**
 * Modal to upgrade project awards.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */

let Form = ({ error, handleSubmit, submitting, submitFailed, onClose, project, papSteps,
             packageItems, upgradeCost, validate, valid, awardedCreatives, newAwards }) => (
  <form onSubmit={handleSubmit}>

    {Object.keys(papSteps).map((key, i) => {
      const items = packageItems.filter((f) => f.step == key && !f.ignoreOnSettings)

      return (
        <fieldset key={i}>
          <Field name={key} component={PackageOptions} items={items} projectData={project}
            currentFeatures={project.features} currentAwards={project.award_rules}
            awardedCreatives={awardedCreatives} downgradeForbidden={true} validate={validate}/>
        </fieldset>
      )
    })}

    <div className="total-wrapper">
      <div className="total">
        Upgrade Cost:
        <span className="value"> {upgradeCost >= 0? <Money value={upgradeCost}/>: '$TBD'}</span>
      </div>
    </div>

    <div className="modal-actions">
      <AnimatedButton processing={submitting} type="submit"
        label={project.is_one_to_one?
          <span>Increase award to <Money value={newAwards[0].price} /></span>:
          <span>Change Awards for <Money value={upgradeCost} /></span>
        }
        disabled={!valid || upgradeCost <= 0} processingLabel="Upgrading..."
        errorMsg={error || submitFailed} successMsg="Done!"/>

      <button className="btn btn-text btn-block" onClick={preventDefault(onClose)}>
        Cancel
      </button>
    </div>
  </form>
)

Form = reduxForm({
  form: "AwardsModal",
})(Form);


export default class AwardsModal extends Component {
  constructor(props) {
    super(props)

    this.state = { done: false, showPaymentMethod: false }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleDone = this.handleDone.bind(this)
    this.togglePaymentMethod = this.togglePaymentMethod.bind(this)
  }

  componentDidMount() {
    const { fetchAwardedCreatives, project } = this.props;
    fetchAwardedCreatives(project.id);
  }

  handleSubmit(formData) {
    const { updateAwardsRequest, project } = this.props

    return updateAwardsRequest(project.id, project.award_rules, formData)
      .then(() => this.setState({ done: true }))
      .catch(res => {
        const status = idx(res, _ => _.data.detail.status);
        /* if the error is related to the payment method being declined, allow user to
           update her payment method */
        if (status == 'processor_declined') {
          this.togglePaymentMethod();
        } else {
          throw new SubmissionError({ _error: 'Failed to upgrade your awards. Please try again.' })
        }
      })
  }

  handleDone() {
    const { onClose, fetchProject, fetchWrapupsIfNeeded, project } = this.props;

    /* close modal and fetch updated project and wrap-ups */
    onClose();
    fetchProject(project.id);
    fetchWrapupsIfNeeded(project.id, true);
  }

  togglePaymentMethod() {
    this.setState({ showPaymentMethod: !this.state.showPaymentMethod });
  }

  renderPaymentMethod() {
    return (
      <div>
        <h2>Upgrade failed</h2>
        <p>
          Your project couldn't be upgraded using your current payment method.
          You can update it below before trying again.
        </p>
        <PaymentMethod />
        <div className="modal-actions">
          <button className="btn btn-primary btn-block" onClick={this.togglePaymentMethod}>
            Done
          </button>
        </div>
      </div>
    )
  }

  render() {
    const { done, showPaymentMethod } = this.state
    const { upgradeCost, onClose } = this.props

    return (
      <ModalDialog modalOpen={true} dialogClasses="awards-modal" closeAction={onClose}
        contentClasses={showPaymentMethod? "overflow-visible" : undefined}
        modalHeader="Change Project Awards">

        {/* Here we need to hide the form with CSS, otherwise we won't be able
            to show its values in the 'done' section after it's submitted. */}
        <div className={done || showPaymentMethod? "hide":""}>
          <Form {...this.props} onSubmit={this.handleSubmit} />
        </div>

        {showPaymentMethod && this.renderPaymentMethod()}

        {done &&
        <div className="done">
          <h3>
            <i className="fa fa-check-circle"/><br/>Awards Updated
          </h3>

          <p>
            Based on your changes, your credit card will be charged <Money value={upgradeCost}/>.
          </p>

          <div className="modal-actions">
            <button className="btn btn-primary" onClick={this.handleDone}>Done</button>
          </div>
        </div>}

      </ModalDialog>)
  }
}

AwardsModal.propTypes = {
  project: PropTypes.object.isRequired,
  awardedCreatives: PropTypes.array,
  papSteps: PropTypes.object,
  packageItems: PropTypes.array,
  upgradeCost: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  updateAwardsRequest: PropTypes.func.isRequired,
  fetchProject: PropTypes.func.isRequired,
  fetchAwardedCreatives: PropTypes.func.isRequired,
  fetchWrapupsIfNeeded: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./project/components/awards_modal.jsx